import { IntlShape } from 'react-intl';

import { ICard } from '../types';

const createDriverFailedTestsCard = (intl: IntlShape): ICard => ({
  id: 'failed_tests_driver',
  cardStatus: 'rejected',
  isExcludedFromProgress: true,
  order: -10,
  title: intl.formatMessage({
    defaultMessage: 'Your account is now blocked',
    id: 'NzjXP5',
    description: '"Failed tests" status card title',
  }),
  desc: intl.formatMessage({
    defaultMessage: 'Pass the tests below to unblock it',
    id: 'dA77Wj',
    description: '"Failed tests" status card description',
  }),
});

export { createDriverFailedTestsCard };
